export default __webpack_public_path__ + "static/media/relay.65686862.svg";